import React from 'react'
import "./style.css"
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react'

const SuccessModal = ({ show, hide }) => {
  return (
    <Modal isOpen={show} onClose={() => hide(false)} isCentered size={"xl"}>
      <ModalOverlay />

      <ModalContent className="modal-content">
        <ModalCloseButton />
        <ModalBody className="modal-body">
          <div className="success-modal-body">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.6268 21.8746C34.3768 28.1246 29.6643 34.0096 23.0518 35.3246C19.8268 35.9669 16.4813 35.5753 13.4918 34.2056C10.5023 32.8359 8.02108 30.558 6.40152 27.6961C4.78195 24.8342 4.10658 21.5343 4.47156 18.2663C4.83654 14.9983 6.22326 11.9287 8.43428 9.49463C12.9693 4.49963 20.6268 3.12463 26.8768 5.62463" stroke="url(#paint0_linear_155_9315)" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.375 19.375L20.625 25.625L35.625 9.375" stroke="url(#paint1_linear_155_9315)" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
            <defs>
              <linearGradient id="paint0_linear_155_9315" x1="20.0009" y1="4.40625" x2="20.0009" y2="35.6256" gradientUnits="userSpaceOnUse">
                <stop stop-color="#54AFF0"/>
                <stop offset="1" stop-color="#005EA3"/>
              </linearGradient>
              <linearGradient id="paint1_linear_155_9315" x1="25" y1="9.375" x2="25" y2="25.625" gradientUnits="userSpaceOnUse">
                <stop stop-color="#54AFF0"/>
                <stop offset="1" stop-color="#005EA3"/>
              </linearGradient>
            </defs>
          </svg>
          <p>Battery swapped successfully</p>
          <Button onClick={() => hide(false)} className='battery-swap-success'>Okay</Button>

          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default SuccessModal
